/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Spinner } from "react-bootstrap";

import useSignin from "./useSignin";
import "./SignIn.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { Carousel } from "antd";

export default (props) => {
  const {
    loading,
    formInputsError,
    showPassword,
    googleLoader,
    microsoftLoader,

    onInputChange,
    onSubmitClick,
    handleShowPassword,
    google_login,
    microsoftLogin,
  } = useSignin(props);

  return (
    <div className="common-login">
      <div className="row no-gutters">
        <div className="col-lg-6">
          <div className="left-img">
            <div className="login-slider">
              <Carousel autoplay arrows>
                <div className="slider-content">
                  <img
                    src="/assets/images/slider-img-1.svg"
                    alt="slider-img"
                    className="slider-img"
                  />
                  <h2 className="text-white mb-2">
                    Simplify Your Recruitment Process
                  </h2>
                  <p className="font-weight-medium text-white">
                    Make recruitment easy for businesses of all sizes.
                    Streamline your hiring process, from job posting to
                    candidate management, and discover the best-fit candidates
                    for your team with Jigsaw's innovative platform.
                  </p>
                </div>
                <div className="slider-content">
                  <img
                    src="/assets/images/slider-img-2.svg"
                    alt="slider-img"
                    className="slider-img"
                  />
                  <h2 className="text-white mb-2">
                    Rescue Hiring Manger & Candidate From Fate
                  </h2>
                  <p className="font-weight-medium text-white">
                    Don't leave recruitment process of hiring manager and
                    candidate’s career to fate. Take control with Jigsaw's
                    intuitive platform, designed to simplify recruitment and
                    elevate your professional growth. Say goodbye to uncertainty
                    and achieve your goals with Jigsaw.
                  </p>
                </div>
                <div className="slider-content">
                  <img
                    src="/assets/images/slider-img-3.svg"
                    alt="slider-img"
                    className="slider-img"
                  />
                  <h2 className="text-white mb-2">
                    Take Control of Your Career with Jigsaw!
                  </h2>
                  <p className="font-weight-medium text-white">
                    Unlock your full potential and achieve your career goals
                    with Jigsaw. Our intuitive platform empowers you with the
                    tools and resources you need to succeed, streamlined job
                    searching and interview preparation. Take control of your
                    future today with Jigsaw.
                  </p>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-wrapper py-5  h-100">
            <div className="text-center">
              <div className="text-center mb-4">
                <img src="/assets/images/logo-svg.svg" alt="zigsaw" />
              </div>
              <h2 className="mb-2">Log in to your account</h2>
              <p className="h3 text-muted font-weight-normal mb-4">
                Welcome back! Dive into your event universe with a single click.
              </p>
            </div>

            <form onSubmit={onSubmitClick}>
              <div className="form-group">
                <label htmlFor="EmailId" className="mb-2 font-weight-medium">
                  Email ID
                </label>
                <input
                  className={`form-control
                    ${
                      formInputsError.email && formInputsError.email.length
                        ? "input-invalid"
                        : ""
                    }`}
                  type="text"
                  placeholder="Enter your Email ID"
                  onChange={(e) => onInputChange(e.target.value, "email")}
                />
                {formInputsError.email && formInputsError.email.length > 0 ? (
                  <p className="text-danger mt-1">
                    <FontAwesomeIcon
                      icon={faTriangleExclamation}
                      className="mr-1"
                    />{" "}
                    {formInputsError.email}
                  </p>
                ) : null}
              </div>
              <div className="form-group">
                <label htmlFor="EmailId" className="mb-2 font-weight-medium">
                  Password
                </label>
                <div className="input-with-icon">
                  <input
                    className={`form-control
                      ${
                        formInputsError.password &&
                        formInputsError.password.length
                          ? "input-invalid"
                          : ""
                      }`}
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your new password"
                    onChange={(e) => onInputChange(e.target.value, "password")}
                  />
                  <span
                    className="input-icon"
                    onClick={() => handleShowPassword()}
                  >
                    {showPassword ? (
                      <img
                        src="../assets/images/eye-icon-2.png"
                        alt="hide icon"
                        className="hide-icon"
                      />
                    ) : (
                      <img
                        src="../assets/images/eye-icon.png"
                        alt="view icon"
                        className="view-icon"
                      />
                    )}
                  </span>
                </div>
                {formInputsError.password &&
                formInputsError.password.length > 0 ? (
                  <p className="text-danger mt-1">
                    <FontAwesomeIcon
                      icon={faTriangleExclamation}
                      className="mr-1"
                    />{" "}
                    {formInputsError.password}
                  </p>
                ) : null}
              </div>

              <div className="d-flex align-items-center justify-content-end">
                <a href="/forgot-password" className="font-weight-medium">
                  Forgot Password?
                </a>
              </div>
              <button
                className="btn btn-primary btn-block text-center my-4"
                type="submit"
                value="Submit"
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    variant=""
                    className="text-white"
                  />
                ) : (
                  "Sign In"
                )}
              </button>
            </form>

            {formInputsError.formSubmitError &&
            formInputsError.formSubmitError.length > 0 ? (
              <div className="form-group">
                <p className="text-danger mt-1">
                  <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    className="mr-1"
                  />{" "}
                  {formInputsError.formSubmitError}
                </p>
              </div>
            ) : null}

            <button
              className="btn btn-outline-primary d-flex w-100 justify-content-center align-items-center mb-2 "
              onClick={(e) => google_login()}
              // disabled={renderProps.disabled}
            >
              Sign In with Google
              {googleLoader ? (
                <Spinner animation="border" variant="primary" />
              ) : (
                <img
                  src="./assets/images/google-icon.png"
                  alt="google icon"
                  className="ml-3"
                />
              )}
            </button>
            <button
              className="btn btn-outline-primary d-flex w-100 justify-content-center align-items-center mb-2"
              onClick={(e) => microsoftLogin()}
              // disabled={renderProps.disabled}
            >
              Sign In with Microsoft
              {microsoftLoader ? (
                <Spinner animation="border" variant="primary" />
              ) : (
                <img
                  src="./assets/images/microsoft-icon.png"
                  alt="microsoft icon"
                  className="ml-3"
                />
              )}
            </button>
            <p className="m-auto text-center">
              Don’t have an account?{" "}
              <a href="/sign-up" className="text-primary font-weight-medium">
                Sign Up
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
